import React, { ChangeEvent } from "react";
import {
    Table, Input, Row, Col, Pagination, Button, Spin, notification, Form, 
    FormInstance, Modal, Popconfirm, Select, TreeSelect, Badge, Breadcrumb, 
    Dropdown, Menu, Space, InputNumber, Empty,
} from "antd";
import {
    BasicStateForListModel
} from "../models";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../redux/reducers";
import { connect } from "react-redux";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { gaEvent } from "../../withTracker"
import { getNoticeSettingList, putNoticeSetting, deleteNoticeSetting } from "../../axios/api.notice"

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
    name: string,
    showAddForm: boolean,
    isUpdate: boolean,
    noticeScene: number,
    noticeType: number,
    noticeTypeDesc: string,
    noticeId: string,
    frequency: number
}
interface propsModel extends RouteComponentProps<any, any, any> {}

const { Column } = Table;
const { Item } = Form;
const mapStatetoProps = (state: RootStoreModel) => ({});

class NoticeIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "NoticeIndex",
            showAddForm: false,
            isUpdate: false,
            noticeScene: 0,  // 0:所有,1:证书过期, 2:新设备注册, 3:设备状态异常
            noticeType: 0,   // 0:所有,1:订阅, 2:提前提醒
            frequency: 0,    // 0:None,1:即时, 2:每天, 3:每月
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            loading: false,
            data: [],
            columns: [],
            noticeId: "",
            noticeTypeDesc: "提前提醒", 
        }
        this.Init();
    }

    Init() {
        this.getList();
    }

    getList(
        pageIndex = this.state.pageIndex, 
        pageSize = this.state.pageSize,
        scenario = this.state.noticeScene,
        type = this.state.noticeType,        
    ) {
        var params = { scenario, type, email: "", pageIndex, pageSize }
        getNoticeSettingList(params).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageIndex: res.pageIndex,
                    pageSize: res.pageSize,
                    totalCount: res.totalCount,
                    loading: false
                })
                if (!res.dataList.length) {
                    notification.warning({ message: <Translation>{t => {return t("查询数据为空")}}</Translation> })
                }
            },
            error => {
                console.log(error);                
                notification.error({ message: <Translation>{t => {return t("查询失败")}}</Translation> })
                this.setState({ loading: false })
            }
        )
    }

    onSearch() {   
        this.setState({ loading: true })     
        this.getList(1);
    }

    transformEmails(emails: any) {
        // 1 若为string则分割转成数组
        if (typeof(emails) === "string") {
            emails = emails.replace(/；/g, ";").split(";")
        }
        // 2 遍历数组，检查邮箱格式是否正确
        const reEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        let isSuccess = true
        emails = emails.filter((email: string) => {
            if (email) {
                if (reEmail.test(email)) {
                    return reEmail.test(email)
                }
                else {
                    isSuccess = false
                }
            }
        })
        
        if (!isSuccess) {
            return isSuccess
        }
        return emails
    }
    
    formOK = () => {
        this.formRef.current?.validateFields().then(
            (res) => { 
                let emails = this.transformEmails(res.emails)
                if (!emails) {
                    notification.error({ message: <Translation>{t => {return t("邮箱格式错误,请检查")}}</Translation> })
                    return
                }
                this.setState({ loading: true })
                const params = {
                    id: this.state.noticeId,
                    notificationScenario: this.state.noticeScene,
                    notificationType: this.state.noticeType,
                    frequency: this.state.frequency,
                    advanceDays: res.advanceDays,
                    emails: emails
                }
                this.putNotice(params)
            },
            error => {
                console.log(error);
            }
        )
    }

    formCancel = () => {
        this.setState({ 
            showAddForm: false, 
            noticeScene: 0,
            noticeType: 0,
            loading: false, 
            noticeId: "",
            frequency: 0 
        })
    }

    updateNoticeSetting = (row: any) => {       
        this.formRef.current?.setFieldsValue({
            noticeScenario: row.notificationScenarioDescription,
            noticeTypeDesc: row.notificationTypeDescription,
            advanceDays: row.advanceDays,
            frequencyDescription: row.frequencyDescription,
            emails: row.emails.join(";"),
        });
        this.setState({ 
            showAddForm: true, 
            isUpdate: true, 
            noticeScene: row.notificationScenario,
            noticeType: row.notificationType,
            frequency: row.frequency,
            noticeId: row.id
        })
    }

    putNotice(params: any) {
        putNoticeSetting(params).then(
            () => {
                // this.getList();
                this.formRef.current?.resetFields();
                this.setState({ 
                    showAddForm: false, 
                    noticeScene: 0,
                    noticeType: 0,
                    loading: false,
                    noticeId: "",
                    frequency: 0 
                })
                this.getList();
                if (this.state.isUpdate) {
                    notification.success({ message: <Translation>{t => {return t("修改成功")}}</Translation> });
                } 
                else {
                    notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
                }
            }, 
            error => {
                console.log(error);
                this.setState({ loading: false });
                if (this.state.isUpdate) {
                    notification.error({ message: <Translation>{t => {return t("修改失败")}}</Translation> });
                } 
                else {
                    notification.error({ message: <Translation>{t => {return t("添加失败")}}</Translation> });
                }
            }
        )
    }

    componentDidMount() {
        console.log("componentDidMount");
    }

    deleteNotice = (id: string) => {
        deleteNoticeSetting(id).then(
            () => {
                notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                this.getList();
            },
            () => {
                notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> });
            }
        )
    }

    render() {
        const { 
            data, 
            showAddForm, 
            isUpdate, 
            loading,
            noticeScene, 
            noticeTypeDesc, 
            pageIndex, 
            pageSize, 
            totalCount 
        } = this.state;
        
        return (
            (<Translation>{t => {
                    return (<>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("设置")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("提醒设置")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("邮件提醒")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 11px 0"}}>
                                    <Space>
                                        <img src="/images/noticeIcon.svg" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("提醒设置")}</span>
                                    </Space>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                <div className="borderBox">
                                    <Row className="mb-3">
                                        <Col span={8}>
                                            <Form.Item label={t("提醒场景")}  name="noticeScene">
                                                <Select 
                                                    allowClear placeholder={t("所有")} 
                                                    onChange={v => this.setState({noticeScene: v ? Number(v) : 0})}
                                                >
                                                    <Select.Option value="0">{t("所有")}</Select.Option>
                                                    <Select.Option value="1">{t("证书过期")}</Select.Option>
                                                    <Select.Option value="2">{t("新设备注册")}</Select.Option>
                                                    <Select.Option value="3">{t("设备状态异常")}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} offset={1}>
                                            <Form.Item label={t("提醒类型")}  name="noticeType">
                                                <Select 
                                                    allowClear placeholder={t("所有")} 
                                                    onChange={v => this.setState({noticeType: v ? Number(v) : 0})}
                                                >
                                                    <Select.Option value="0">{t("所有")}</Select.Option>
                                                    <Select.Option value="1">{t("订阅")}</Select.Option>
                                                    <Select.Option value="2">{t("提前提醒")}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col offset={1}>
                                            <Form.Item>
                                                <Button type="primary" onClick={
                                                    () => { 
                                                        this.onSearch(); 
                                                        gaEvent("notice", "onClick", "onSearch") 
                                                    }
                                                }>{t("查询")}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="borderBox">
                                    <Row style={{ width: "100%", marginBottom: 8 }}>
                                        <Col className="ms-auto">
                                            <Button type="primary" onClick={
                                                () => {
                                                    this.setState({ 
                                                        showAddForm: true, 
                                                        isUpdate: false, 
                                                        noticeScene: 1,
                                                        noticeType: 2 
                                                    });                                            
                                                    this.formRef.current?.resetFields(); gaEvent("addNotics", "onClick", "添加提醒")
                                                }
                                            }><PlusOutlined />{t("添加提醒")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Table 
                                        size="middle" 
                                        dataSource={data} 
                                        style={{width: "100%"}} 
                                        pagination={false}
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                    >
                                        <Column
                                            key="key"
                                            dataIndex="key"
                                            title={t("序号")}
                                            render={(v, d, i) => i + 1}
                                        ></Column>
                                        <Column
                                            title={t("提醒场景")}
                                            key="notificationScenarioDescription"
                                            dataIndex="notificationScenarioDescription"
                                        ></Column>
                                        <Column
                                            title={t("提醒类型")}
                                            key="notificationTypeDescription"
                                            dataIndex="notificationTypeDescription"
                                        ></Column>
                                        <Column title={t("时间")} key="frequencyDescription" dataIndex="frequencyDescription"></Column>
                                        <Column 
                                            title={t("邮箱")} key="emails" dataIndex="emails" 
                                            render={(v) => v.join(";")}
                                        ></Column>
                                        <Column
                                            title={t("操作")}
                                            key="id"
                                            dataIndex="id"
                                            render={(v, row: any, index) => {                                        
                                                return (
                                                    <Space size={8}>
                                                        <Button type="link" block onClick={
                                                            () => {
                                                                this.updateNoticeSetting(row); 
                                                                gaEvent("noticeSetting", "onClick", "updateNoticeSetting");
                                                            }
                                                        }>{t("编辑")}
                                                        </Button>
                                                        <Popconfirm
                                                            title={`${t("确认删除")}？`}
                                                            onConfirm={() => {
                                                                this.deleteNotice(row.id); 
                                                                gaEvent("notice", "onClick", "deleteManager") 
                                                            }}
                                                            okText={t("确认")}
                                                            cancelText={t("取消")}
                                                        >
                                                            <Button type="link" block>{t("删除")}</Button>
                                                        </Popconfirm>
                                                    </Space>
                                                )
                                            }}></Column>
                                    </Table>
                                    <Pagination
                                        style={{ textAlign: "right", marginTop: "20px" }}
                                        pageSize={ pageSize }
                                        current={ pageIndex }
                                        total={ totalCount }
                                        showTotal={ (total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}` }
                                        onChange={ (page, pageSize) => this.getList(page, pageSize) }
                                        onShowSizeChange={ (current, size) => this.getList(current, size) }
                                    ></Pagination>
                                </div>
                            </Row>
                        </div>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={showAddForm}
                            destroyOnClose={true}
                            title={this.state.isUpdate ? t("修改提醒") : t("添加提醒")}
                            forceRender={true}
                            width={"650px"}
                            onOk={() => this.formOK()}
                            onCancel={() => this.formCancel()}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                labelCol={{span: 6}}
                                ref={this.formRef}
                                layout="vertical"
                                initialValues={{ 
                                    noticeScenario: t("证书过期"), 
                                    noticeTypeDesc: t(noticeTypeDesc), 
                                    noticeTime: "", 
                                    email: "" 
                                }}
                            >
                                <Item label={t("提醒场景")} name="noticeScenario" rules={[{ required: true }]}>
                                    <Select disabled={isUpdate} 
                                        onChange={
                                            (v) => {
                                                this.formRef.current?.resetFields();
                                                this.setState({noticeScene: Number(v), noticeType: v === "1" ? 2 : 1});
                                                this.formRef.current?.setFieldsValue({
                                                    "noticeTypeDesc": v === "1" ? t("提前提醒") : t("订阅"),
                                                    "noticeScenario": v === "1" ? t("证书过期") : v === "2" ? t("新设备注册") : t("设备状态异常")
                                                });
                                            }
                                        }
                                    >
                                        <Select.Option value="1">{t("证书过期")}</Select.Option>
                                        <Select.Option value="2">{t("新设备注册")}</Select.Option>
                                        <Select.Option value="3">{t("设备状态异常")}</Select.Option>
                                    </Select>
                                </Item>

                                <Item label={t("提醒类型")} name="noticeTypeDesc">
                                    <Input disabled />
                                </Item>

                                <Item 
                                    label={t("提前天数")} 
                                    name="advanceDays" 
                                    rules={[{ required: true && noticeScene === 1 }]} hidden={noticeScene !== 1}
                                >
                                    <InputNumber style={{width: "100%"}} min="0"/>
                                </Item>

                                <Item 
                                    label={t("提前频率")} 
                                    name="frequencyDescription" 
                                    rules={[{ required: true && noticeScene !== 1 }]} hidden={noticeScene === 1}
                                >
                                    <Select onChange={(v) => this.setState({frequency: Number(v)})}>
                                        <Select.Option value="1">{t("即时")}</Select.Option>
                                        <Select.Option value="2">{t("每天")}</Select.Option>
                                        <Select.Option value="3">{t("每月")}</Select.Option>
                                    </Select>
                                </Item>

                                <Item 
                                    label={t("邮箱")} name="emails" 
                                    rules={[{ required: true }]} 
                                    extra={<><InfoCircleOutlined /> {t("多个邮箱中间请用分号(不区分中英文)隔开")}</>}
                                >
                                    <Input />
                                </Item>
                            </Form>
                        </Modal>
                    </>);
                }}</Translation>)
        );
    }
}

export default connect(mapStatetoProps, {})(NoticeIndex);